export const ADD_TO_CART = 'cart/AddToCart';
export const INCREMENT_QUANTITY = 'cart/incremenyQuantity';
export const DECREMENT_QUANTITY = 'cart/decremenyQuantity';
export const DELETE_ITEM = 'cart/deleteItem';
